import styles from './RotatingText.module.scss';

interface TextRotatorProps {
  items: ReadonlyArray<string>;
}

export const RotatingText: React.FC<TextRotatorProps> = ({ items }) => {
  return (
    <span aria-hidden="true" className={styles.rotatingText} data-testid="rotating-text">
      <span>
        {items.map(item => (
          <span className={styles.item} key={item}>
            {item} <br />
          </span>
        ))}
      </span>
    </span>
  );
};
